import { JSX, useEffect, useRef, useState } from "react";

import { Icon } from "components/icon/Icon";

import "./MenuDropdown.scss";

export type MenuItem = {
  content: JSX.Element | string;
  notClickable?: boolean;
  persistOnClick?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  hasDivider?: boolean;
  className?: string;
};

type Props = {
  toggleText: string;
  hasCaret?: boolean;
  className?: string;
  menuItems: MenuItem[];
};

export default function MenuDropdown({
  toggleText,
  hasCaret = true,
  className = "",
  menuItems,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const menuDropdownRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        menuDropdownRef.current &&
        !menuDropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOnItemClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    item: MenuItem,
  ) => {
    if (item.onClick) {
      item.onClick(e);
      if (!item.persistOnClick) {
        setIsOpen(false);
      }
    }
  };

  return (
    <div ref={menuDropdownRef}>
      <button className="dropdownToggle" onClick={() => setIsOpen(!isOpen)}>
        {toggleText}
        {hasCaret && (
          <Icon className="dropdownCaret" name="fas fa-chevron-down" />
        )}
      </button>
      {isOpen && (
        <div className="dropdownMenu">
          {menuItems.map((item, i) => (
            <div key={i}>
              <div
                className={`dropdownItem ${item.className ?? ""} ${item.notClickable ? "notClickable" : ""}`}
                onClick={(e) => handleOnItemClick(e, item)}
              >
                {item.content}
              </div>
              {item.hasDivider && <hr className="dropdownDivider" />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
